export default function eraseCookie(name) {
	document.cookie = name+'=; Max-Age=-99999999;'
}


// WEBPACK FOOTER //
// ./src/utilities/session/removeCookie.js